export default __webpack_public_path__ + "static/media/project_ob.bc81e943.svg";